import API from "./api";

export const GetPayerPlan = (configUrl: string) => API.get(`${configUrl}api/eligibility/Payers`)
   
export const diseaseTypeRespValues = (
    configUrl: string,
    diseaseIdentifier: string
  ) => API.get(`${configUrl}api/master/IcdDiagnosisType?searchText=${diseaseIdentifier}`);

export const GetReferralSourceMaster = (configUrl: any) =>
  API.get(`${configUrl}api/master/ReferralSourceFacility`);

export const IcdCodeTypeData = (configUrl: string) =>
  API.get(`${configUrl}api/master/DiagnosisType`);
